import type { StepType } from '@reactour/tour'
import type { TourStepDto } from '@/types/tourSteps'
import { TourStepBody } from './TourStepBody'

export function toStepType(dto: TourStepDto): StepType {
  return {
    selector: dto.selector,
    position: (dto.position ?? undefined) as StepType['position'],
    content: (
      <div>
        <strong>{dto.title}</strong>
        <TourStepBody body={dto.body} />
      </div>
    ),
  }
}
